/**
 * The API sends failed redirect flows to `/login?error=<code>`. Our own code
 * comes from the guest rule; the rest are Better Auth's OAuth callback codes.
 */
const MESSAGES: Record<string, string> = {
  GUEST_ACCOUNT_EXISTS:
    "That email already belongs to another Pax account. You are still signed in as a guest.",
  GUEST_MUST_LINK_ACCOUNT:
    "Use Save progress to connect an account, or sign out before signing in.",
  ACCOUNT_DELETED: "That email belonged to a Pax account that has been deleted.",
  LINKING_DIFFERENT_EMAILS_NOT_ALLOWED:
    "Linked provider accounts must use the same email as your Pax account.",
  account_already_linked_to_different_user:
    "That provider account already belongs to another Pax account. You are still signed in as a guest.",
  email_does_not_match: "The provider email does not match your Pax account.",
  access_denied: "Sign-in was cancelled.",
  email_not_found: "The provider did not share an email address, so no account could be created.",
  BANNED_USER: "Sorry, this account has been banned from Pax Historia.",
};

const FALLBACK = "Sign-in did not complete. Please try again.";

export function signInErrorMessage(code: string | undefined): string | undefined {
  if (!code) return undefined;
  return MESSAGES[code] ?? FALLBACK;
}
